import React from "react";
import { compact } from "lodash";
import { Location } from "../Location";
import { CustomerEditor } from "../../customers/CustomerEditor/CustomerEditor";
import { FormData } from "../../customers/CustomerEditor/utils";

interface Params {
  customerId: string;
}

export class CustomerEditorLocation extends Location<Params> {
  constructor(customerId?: string, private initialValues?: Partial<FormData>) {
    super({ customerId });
  }

  render() {
    return (
      <CustomerEditor
        id={this.params.customerId}
        initialData={this.initialValues}
        onClose={this.navigation.close}
      />
    );
  }

  toURI() {
    const { customerId } = this.params;
    const parts = compact(["/customers", customerId || "new", customerId && "edit"]);
    return parts.join("/");
  }
}
